import {Directive, ViewContainerRef, inject} from '@angular/core';

@Directive({ selector: '[toolbarMenuHost]' })
export class ToolbarMenuHostDirective {
  viewContainerRef = inject(ViewContainerRef);

}
